import { format, parseISO, isAfter, isBefore, addDays } from 'date-fns';
import { de } from 'date-fns/locale';

export const formatDate = (dateString: string): string => {
  try {
    const date = parseISO(dateString);
    return format(date, 'dd.MM.yyyy', { locale: de });
  } catch {
    return 'Ungültiges Datum';
  }
};

export const formatDateTime = (dateString: string): string => {
  try {
    const date = parseISO(dateString);
    return format(date, 'dd.MM.yyyy HH:mm', { locale: de });
  } catch {
    return 'Ungültiges Datum';
  }
};

export const isExpiringSoon = (dateString: string, days: number = 30): boolean => {
  try {
    const date = parseISO(dateString);
    const now = new Date();
    const warningDate = addDays(now, days);
    return isAfter(date, now) && isBefore(date, warningDate);
  } catch {
    return false;
  }
};

export const isExpired = (dateString: string): boolean => {
  try {
    const date = parseISO(dateString);
    const now = new Date();
    return isBefore(date, now);
  } catch {
    return false;
  }
};

export const getDaysUntilExpiry = (dateString: string): number => {
  try {
    const date = parseISO(dateString);
    const now = new Date();
    const diffTime = date.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  } catch {
    return 0;
  }
}; 